import { ItemID } from "types/common";
import { RelationsToBE } from "types/entities/Relations";

import { useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useMessage } from "hooks/useMessage";
import { useTranslations } from "translations/useTranslations";

import { getItemRelationsUrl } from "api/rootUrl";

const deleteRelationForTaxonomyItem = ({ itemID, data }: { itemID: ItemID; data: RelationsToBE }) => {
  return axios.delete<ItemID>(getItemRelationsUrl(itemID), {
    data,
  });
};

export const useDeleteRelationForTaxonomyItem = () => {
  const { showSuccess } = useMessage();
  const translations = useTranslations();

  const { mutateAsync } = useMutation({
    mutationFn: deleteRelationForTaxonomyItem,
    onSuccess: (_, { itemID }) => {
      showSuccess(translations["relation.messages.delete.success"]);
    },
  });

  return useCallback(
    (itemID: ItemID, data: RelationsToBE) => {
      mutateAsync({ itemID, data });
    },
    [mutateAsync]
  );
};
